import type { OrganizationStaffMember } from '../../../../../types/account';

const ADMIN_MEMBER_ROLES = ['admin', 'member'] as const;

export const hasAdminOrMemberRole = (roles: string[]): boolean =>
  ADMIN_MEMBER_ROLES.some((role) => roles.includes(role));

export const isAssignableOrgStaffRole = (role?: string | null): boolean => {
  const normalized = (role || '').toLowerCase();
  return normalized === 'admin' || normalized === 'member';
};

export const filterAssignableOrgStaff = (staff: OrganizationStaffMember[]): OrganizationStaffMember[] =>
  staff.filter((member) => isAssignableOrgStaffRole(member.role));
